import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getCurDeterminantTypes = state => state.models[name].data;
export const CurDeterminantTypesLoading = state => state.models[name].loading;